var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedpopup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 22V21.2C32 20.0799 32 19.5198 31.782 19.092C31.5903 18.7157 31.2843 18.4097 30.908 18.218C30.4802 18 29.9201 18 28.8 18H27.2C26.0799 18 25.5198 18 25.092 18.218C24.7157 18.4097 24.4097 18.7157 24.218 19.092C24 19.5198 24 20.0799 24 21.2V22M26 27.5V32.5M30 27.5V32.5M19 22H37M35 22V33.2C35 34.8802 35 35.7202 34.673 36.362C34.3854 36.9265 33.9265 37.3854 33.362 37.673C32.7202 38 31.8802 38 30.2 38H25.8C24.1198 38 23.2798 38 22.638 37.673C22.0735 37.3854 21.6146 36.9265 21.327 36.362C21 35.7202 21 34.8802 21 33.2V22",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 37C23.0293 37 19 32.9707 19 28C19 23.0293 23.0293 19 28 19C32.9707 19 37 23.0293 37 28C37 32.9707 32.9707 37 28 37ZM28 35.2C29.9096 35.2 31.7409 34.4414 33.0912 33.0912C34.4414 31.7409 35.2 29.9096 35.2 28C35.2 26.0904 34.4414 24.2591 33.0912 22.9088C31.7409 21.5586 29.9096 20.8 28 20.8C26.0904 20.8 24.2591 21.5586 22.9088 22.9088C21.5586 24.2591 20.8 26.0904 20.8 28C20.8 29.9096 21.5586 31.7409 22.9088 33.0912C24.2591 34.4414 26.0904 35.2 28 35.2ZM27.1 23.5H28.9V25.3H27.1V23.5ZM27.1 27.1H28.9V32.5H27.1V27.1Z",
    fill: "#E8AA4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedpopup);
export default __webpack_public_path__ + "static/media/Featuredpopup.32e7f69a5d41d9db5ed77053ecd6a2f9.svg";
export { ForwardRef as ReactComponent };